/* global angular */

var moment = require('moment')

angular.module('AemExtUpdates')
  .component('filesFilter', {
    template: require('./files-filter.component.tpl.html'),
    controller: FilesFilterCtrl,
    controllerAs: 'vm',
    bindings: {
      onChanged: '&'
    }
  })

FilesFilterCtrl.$inject = []

function FilesFilterCtrl () {
  var vm = this

  vm.$onInit = function () {
    vm.from = null
    vm.to = null
    vm.currentDate = new Date()
    vm.changed = changed
  }

  function changed () {
    vm.onChanged({
      fromLocalDate: vm.from && moment(vm.from).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      toLocalDate: vm.to && moment(vm.to).endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    })
  }
}
